import { supabase } from "../supabase";

const throwOnError = async (query) => {
  const result = await query;
  if (result.error) throw result.error;
  return result;
};

export const buildSelfServiceProfileUpdate = (user, profileForm) => ({
  id: user.id,
  email: user.email,
  name: [profileForm.firstName.trim(), profileForm.middleName.trim(), profileForm.lastName.trim()].filter(Boolean).join(" "),
  marketing_opt_in: user.marketingOptIn,
});

export const approveUser = async (record, { fromPending, profileUpdates = {}, notification = {} }) => {
  const profileId = fromPending ? record.auth_user_id : record.id;

  if (profileId) {
    await throwOnError(
      supabase.from("profiles").update({ ...profileUpdates, status: "active" }).eq("id", profileId),
    );
  }

  await throwOnError(
    supabase.from("pending_users")
      .update({ status: "approved" })
      .eq(fromPending ? "id" : "auth_user_id", fromPending ? record.id : profileId),
  );

  if (record.email) {
    try {
      const { error } = await supabase.functions.invoke("send-approval-notification", {
        body: { to: record.email, userName: record.name ?? record.email, ...notification, decision: "approved" },
      });
      if (error) console.error("Approval email failed:", error);
    } catch (error) {
      console.error("Approval email failed:", error);
    }
  }
};
